import type { SubscriptionStatus } from '../api/subscriptions.service';

export const STATUS_LABEL: Record<SubscriptionStatus, string> = {
  TRIALING: 'Trial',
  ACTIVE: 'Ativa',
  PAST_DUE: 'Atrasada',
  CANCELED: 'Cancelada',
  PENDING_PAYMENT: 'Aguardando pagamento',
};

export const STATUS_CLASS: Record<SubscriptionStatus, string> = {
  TRIALING: 'bg-amber-100 text-amber-800',
  ACTIVE: 'bg-green-100 text-green-800',
  PAST_DUE: 'bg-red-100 text-red-800',
  CANCELED: 'bg-gray-100 text-gray-800',
  PENDING_PAYMENT: 'bg-orange-100 text-orange-800',
};

export function formatSubscriptionDate(dateStr: string) {
  return new Date(dateStr).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatSubscriptionPrice(cents: number, currency = 'BRL') {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(cents / 100);
}
